<!--
================================================
Un composant affichant la liste des clients auxquels l'utilisateur à accès

Url d'accès :
http://localhost:8080/fr/cronocloud-inc/clients

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="ClientListComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
<!--        {{'Hello ! :) I am ' + $options.name}}-->

      <!--  Bloc affiché en cas d'absence de projet-->
      <empty-view-bloc-comp
          v-show="clientCount==0 && componentIsReady"
          v-bind:emptyItemName="'Client'" v-bind:noItemTitle="$t('aucunClient')" v-bind:c2aTxt="$t('créezVotrePremierClientPourCommencer')" ></empty-view-bloc-comp>

        <!--  Bloc placeholder affiché pendant le chargement des timerecords-->
        <div class="appBloc" id="blocLoadingClients" v-if="!componentIsReady">
            <table class="table is-fullwidth">
                <tbody>
                <loading-timerecord-comp v-for="index in 10" :key="index"></loading-timerecord-comp>
                </tbody>
            </table>
        </div>

        <!-- liste des clients -------------------------------------------->
        <div v-else-if="clientCount > 0">
          <div class="table-container"> <!-- rend le tableau scrollable si besoin (pour les mobiles)-->
              <table class="appBloc table is-fullwidth client" id="clientTable">

                <thead>
                <tr class="lineClient">
                    <th colspan="" class="theadClient is-uppercase">{{$t('Client')}}</th>
                    <th colspan="" class="is-uppercase is-hidden-mobile">{{$t('DateCréation')}}</th>
                    <th colspan="" class="is-uppercase is-hidden-mobile"> {{$t('archivage')}}</th>
                    <th colspan="" class="is-uppercase "></th>
                </tr>
                </thead>

                <tbody >
                <tr v-for="(client,index) in clients" v-bind:key="client.slug"  v-bind:id="'client_'+client.slug" v-bind:class="'client_'+index">

                    <td class="clientName">
                        <span v-if="client.isArchived" v-bind:title="$t('leProjetEstArchivé')">
                            <font-awesome-icon  class="icon archivedClient" :icon="['fas', 'folder']" />
                        </span>
                        <span v-else>
                            <font-awesome-icon class="icon" :icon="['fas', 'user-tie']" />
                        </span>

                        <!--// Lien de modification si l'user a la permission d'édition -->
                        <a v-if="userCanEditClient()"
                           v-bind:title="$t('modifierLeProjet')" class="name" v-on:click="modifyClient(client)"
                           v-bind:class="{'archivedClient':client.isArchived}">{{client.name}}</a>

                        <!--// affichage du nom du client si l'user n'a pas de permission d'édition -->
                        <span v-else  class="name" v-bind:class="{'archivedClient':client.isArchived}">{{client.name}}</span>
                    </td>

                    <td class="createdAt is-hidden-mobile" v-bind:title="$t('DateCréation')">{{$moment(client.createdAt).fromNow()}}</td>


                    <td class="isArchived is-hidden-mobile">
                        <span class="tagArchived"  v-if="client.isArchived">
                            <font-awesome-icon  class="icon" :icon="['fas', 'folder']" />
                            {{$t('archivé')}}
                        </span>
                        <span v-else>{{'-'}}</span>
                    </td>

                    <td class="menuLink" v-bind:title="$t('afficherLeSousMenu')">
                        <font-awesome-icon
                                v-if="userCanEditClient()"
                                v-bind:id="'menuOpener_'+client.slug"
                                v-on:click="showMenu(index)" class="icon menuOpener"
                                :icon="['fas', 'ellipsis-v']"/>
                    </td>


                    <div class="menu" v-show="client.showMenu" v-on:mouseleave="hideMenus()">
                        <ul>
                            <li v-on:click="modifyClient(client)" class="editLink">
                                <font-awesome-icon class="icon" :icon="['fas', 'pencil-alt']"/>
                                <a>{{$t('modifier')}}</a>
                            </li>

                            <li class="unArchiveLink" v-if="client.isArchived" v-on:click="archiveClient(client,'restore')">
                                <font-awesome-icon class="icon" :icon="['fas', 'folder']"/>
                                <a >{{$t('désarchiver')}}</a>
                            </li>
                            <li  class="archiveLink" v-else v-on:click="archiveClient(client,'archive')">
                                <font-awesome-icon class="icon" :icon="['fas', 'folder']"/>
                                <a  >{{$t('archiver')}}</a>
                            </li>

                            <li class="deleteLink" v-bind:id="'deleteLink_'+client.slug"
                            >
                                <font-awesome-icon class="icon" :icon="['fas', 'trash-alt']"/>
                                <a v-on:click="openModalDeleteClient(client)">{{$t('supprimer')}}</a>
                            </li>
                        </ul>
                    </div>
                </tr>

                </tbody>
            </table>
          </div>
        </div>

    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    import LoadingTimerecordComp from "./PlaceholderTimerecordComp";

    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import _ from 'lodash'
    import EmptyViewBlocComp from "@/components/EmptyViewBlocComp";
    import TrackingMixin from "@/mixins/TrackingMixin";

    // import vClickOutside from 'v-click-outside'

    export default {
        name: 'ClientListComp', //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin, TrackingMixin],
        components: {EmptyViewBlocComp, LoadingTimerecordComp},

        data: function () {
            return {
                locale : this.$route.params.locale,
                // pour les composants où l'user est identifié ///////////////////////
                organizationSlug: this.$route.params.organization,
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
                componentIsReady : false, // indique quand le composant est prêt à être affiché (clients chargés)
                clientCount : 0, // le nombre total de client dans la vue

              // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                clients: state => state.ClientsView.clients,
                themeToDisplay: state => state.app.themeToDisplay
            }),
        },
      watch: {
        clients :  function (){ // maj le nombre de client quand les clients sont modifiés
          this.clientCount = this.clients.length
        }
      },

        methods: {

            /**
             * Met le store à jour avec editedClient
             * @param editedClient object le client mis à jour à mettre dans le store
             * inspiré de https://stackoverflow.com/questions/27641731/is-there-a-function-in-lodash-to-replace-matched-item
             *
             */
        updateClientInStore(editedClient){
            // Trouve l'index de l'objet à remplacer dans le store
            var index = _.findIndex(this.clients, {slug: editedClient.slug});
            editedClient.showMenu = false // on définit l'affichage du .menu à false

            // Remplace l'objet à l'index précédemment trouvé
            this.clients.splice(index, 1, editedClient);

        },

            /**
             * Ajoute un client dans le store.
             * Utilisé pour maj le dom après la création d'un client.
             * @param client2Add object le client à ajouter dans le store
             *
             */
            addClientInStore(client2Add){
                let clientsInStore =  this.clients
                // on ajoute le client au début du tableau (car loadClient() charge en desc)
                client2Add.showMenu = false // on initialise l'affichage du .menu à false

                clientsInStore.unshift(client2Add)
                this.$store.commit('UpdateClientsViewClients', clientsInStore)
            },

            /**
             * Supprime un client dans le store.
             * Utilisé pour maj le dom après la suppression d'un client.
             * @param client2Del object le client à supprimer dans le store
             *
             */
            removeClientInStore(client2Del){
                // Trouve l'index de l'objet à modifier dans le store
                var index = _.findIndex(this.clients, {slug: client2Del.slug});
                client2Del.showMenu = false // on réinit l'affichage du .menu à false (oui l'élément est supprimé mais un autre a pu prendre sa place) @todo améliorer car imparfait

                // supprime l'objet à l'index précédemment trouvé
                this.clients.splice(index, 1);
            },

            /**
             * Récupère les clients de l'organization
             *
             * @param String filter | une chaîne pour filtrer par nom des clients ET clients
             */
            loadClients(filter) {
                let self = this;
                self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/clients`,
                    {
                        params: {
                            filter: filter,
                            sort: 'desc', // on récupère les plus récents en premier
                            archive: 'archive', //@todo on récupère les clients archivés + actifs
                        },
                        headers: {Authorization: self.$auth.header()}
                    }
                )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // on injecte une propriété 'showMenu' dans chaque clients (qui sert à gérer l'affichage des .menu)
                        let clients = []
                        response.data.forEach(function (value) {
                            value.showMenu = false;
                            clients.push(value);
                        })

                        // stockage dans le store
                        self.$store.commit('UpdateClientsViewClients', response.data)
                        self.componentIsReady = true

                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')

                            let errorCode = '0037'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error fetching clients', 'fatal': false})

                            self.$mixpanel.track('global error displayed', {"id": errorCode,"detail": "error fetching clients"})
                            self.$sentry.captureMessage(`Error ${errorCode} > "error fetching clients : ${error}`, 'error')

                        }
                    })
                    .then(() => {
                        // toujours exécuté
                    })
            },


            /**
             * Masque tous les éléments .menu
             **/
            hideMenus() {
                this.clients.forEach(function (value) {
                    value.showMenu = false;
                })
            },
            /**
             * Affiche l'élément .menu dont index est passé.
             * @param index int | Index du menu à afficher
             */
            showMenu(index) {
                this.hideMenus(); // on masque un éventuel .menu affiché au préalable
                this.clients[index].showMenu = true;
            }

            /**
             * Ouvre la modal client management pour modifier un client
             * @param clientToModify L'objet Projet à modifier
             */
            , modifyClient(clientToModify) {
                this.$root.$emit('show_modal_client_management','edition', clientToModify)
            }

            /**
             * Archive/restaure un client
             * @param client Object client à archiver
             * @param mode String L'action à effectuer (archive/restore)
             */
            ,archiveClient(client,mode){

                const params = {}
                switch (mode) {
                    case  'archive': params.isArchived= true; break;
                    case  'restore': params.isArchived= false; break;
                }

                let self = this
                return self.$http
                    .patch(`/organizations/${self.organizationSlug}/clients/${client.slug}`,
                        params,
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                        // on maj le store avec le client modifié
                        self.updateClientInStore(response.data)

                        // tracking
                        self.$mixpanel.track("Client archived", {"timerecord":response.data.slug});
                        self.ga4GlobalEventTrack('Client archived' , {})

                      // masquage d'une éventuelle erreur
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false)
                        return {}
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                            self.logToSentry(self, error, 'error')

                            let errorCode = '0030'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error archiving client', 'fatal': false})
                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error archiving client"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error archiving client : ${error}`, 'error')
                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            }

            /**
             * Déclenche l'ouverture de la ModalDeleteClientComp
             * @param client Object client à supprimer
             */
            ,openModalDeleteClient(client){
                this.$root.$emit('show_modal_delete_client',client)
            }


            /**
             * Retourne true si l'utilisateur actuel à le droit de modifier le client
             * @param client Object | le client à tester
             * @return {boolean}
             */
            ,userCanEditClient(){
                // Pour modifier un Client ROLE_ADMIN dans la même organization
                if(this.$auth.hasRole('ROLE_ADMIN') && this.$auth.getOrganization() == this.organizationSlug){
                    return true
                }

            }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
            // this.logToSentry(this, 'push a log to sentry :)', 'info')


            // Chargement initial des clients
            this.loadClients()

            // listener de l'event new_client_added, pour m.a.j les clients si un client est ajouté
            this.$root.$on('new_client_added', (clientAdded) => {
                this.addClientInStore(clientAdded)
            })

            // listener de l'event client_edited, pour m.a.j les clients si un client est modifié
            this.$root.$on('client_edited', (clientEdited) => {
               this.updateClientInStore(clientEdited)
            })
            // listener de l'event client_deleted, pour m.a.j les clients si un client est supprimé
            this.$root.$on('client_deleted', (clientEdited) => {
               this.removeClientInStore(clientEdited)
            })

        },
      beforeDestroy() {
        /**
         * Fix un potentiel bug d'insertion du client en double après création https://gitlab.com/ousmane1/kronocloud/-/issues/251
         * N'a pas réellement pu être rerpoduit en dev donc à voir si le problème persiste
         * inspiré de : https://stackoverflow.com/a/61049328/666416 | https://charlietheprogrammer.com/duplicate-vue-event-listeners-and-how-i-solved-them
         **/
        this.$root.$off('new_client_added', () => {
        })
      },
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";

    #ClientListComp{

      table.client{

        /*th{*/
        /*    border: dashed 1px red;*/
        /*}*/
        /*td{*/
        /*    border: dashed 1px lightblue;*/
        /*}*/

        .theadClient{
            /*padding-left: 1rem;//surtout pour mobile*/
        }

        .icon{
            padding-top: 0.5rem;
            margin-right: 0.4rem;
        }

        .clientName{
            min-width: $variableTxtMinWidth;
            padding-left: 2rem;
            @include mobile{
                padding-left: 1rem;
            }
            font-weight: bold;

            .name {
                color: #666;
                &.archivedClient {
                    color: #999;
                }
            }

            .icon{
                &.archivedClient {
                    color:#999 ;
                }
            }

        }

        .menuLink{
            padding: 0;

            .icon{
                /*border:dashed 1px lightblue;*/
                cursor: pointer;
                margin-left: .2rem;
                font-size: 1.2rem;
                cursor: pointer;

                @include mobile{
                  margin: 0.9rem 2rem 0 1.5rem;
                }
                color:#ccc;

                &:hover{
                    color:$brandPrimary
                }


            }

        }
        .tagArchived{
            background:$brandYellow;
            padding: 0.3rem 0.5rem;
            border-radius: 3px;
            font-size: 0.85rem;
            color:#666;
            display: inline-block;
            min-width: 5.5rem;
          .icon{
            padding: 0;
            vertical-align: middle;
          }
        }


    }

      //////////////////////////////////////
      // DARK UI ///////////////////////////
      &.darkMode {

          .clientName{

            .name {
              color: $darkContrastTxt !important;
              &.archivedClient {color: $disabledTableItemColor !important;}
            }

            .icon{ &.archivedClient {color:$disabledTableItemColor !important;} }

          }
          .tagArchived{
            background-color: $darkTxt !important;
            color:$darkBg !important;
          }


        }

    }


</style>
